import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { ILaunchPadApp } from '@app/models/launchpadApp.model';
import { useTypedTranslation } from '@app/hooks';
import { PasslyButton } from '@app/components';
import { launchPadService } from '@app/services';
import { genericErrorToast } from '@app/helpers';
import { confirm } from '@app/components/Modal/confirmModal';
import { IModalData, ModalComponent } from '@app/components';
import EditApplicationDialog from '@app/pages/launchPad/dialogs/editApplication.dialog'
import { useSelector } from 'react-redux';

interface IProps {
    app: ILaunchPadApp;
    handleRefreshPage: Function;
}

const LaunchPadApp: React.SFC<IProps> = ({ app, handleRefreshPage }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const modalSwitchState: boolean = useSelector((state: any) => state.modal);
    const [modalData, setModalData] = useState<IModalData>({
        headerTitle: '',
        modalSwitcher: modalSwitchState
    });

    const [openUpdateModal, setOpenUpdateModal] = useState(false);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { translation } = useTypedTranslation();

    const launchUrl = () => {
        if (app.RequiresProvisioning) {
            return '#';
        }

        if (app.Workflow) {
            return '/trust/launch?WorkflowId=' + app.Id;
        }

        let url = '/trust/launch?ApplicationId=' + app.Id;

        if (app.IsDeepLink) {
            if (app.ReplyToUrl.indexOf('wreply:') === 0) {
                url += '&deepLink=' + app.ReplyToUrl;
            } else {
                url += '&deepLink=' + encodeURIComponent(app.ReplyToUrl);
            }
        }

        return url;
    };

    const target = () => {
        if (app.RequiresProvisioning) {
            return '_self';
        }

        return '_blank';
    };

    const reportApp = (appId: string) => {
        let jsonObject: any = {};
        jsonObject.AppId = appId;

        launchPadService.reportApp(jsonObject, handleSuccessReportApp, genericErrorToast);
    };

    const handleSuccessReportApp = (response: any) => {
        confirm(translation('WORKFLOW_FLAG_BODY'),
            translation('OK'),
            undefined,
            translation('WORKFLOW_FLAGGED')).then(
                () => {
                    // do nothing on ok
                },
                () => {
                    // do nothing on cancel
                }
            );
    };

    const deleteApp = (appId: string) => {
        launchPadService.deleteApp(appId, handleSuccessDeleteApp, genericErrorToast);
    };

    const handleSuccessDeleteApp = (response: any) => {
        // refresh screen
        handleRefreshPage(true);
    };

    const updateApp = () => {
        setOpenUpdateModal(true);

        setModalData({
            headerTitle: translation('UPDATE_WORKFLOW_HEADER'),
            modalSwitcher: modalSwitchState,
            form: <EditApplicationDialog appId={app.Id} dialogOpen={handleModalCloseCallback} />
        });
    };

    const handleModalCloseCallback = (close?: boolean) => {
        if (close !== undefined) {
            setOpenUpdateModal(false);
        }
        else {
            setOpenUpdateModal(!openUpdateModal);
        }
    };

    return (
        <>
            <ModalComponent localModalSwitcher={openUpdateModal} modalSwitcherCallback={handleModalCloseCallback} {...modalData} />
            <div className={`tile launchpad__app ${(app.Enabled && app.Provisioned) ? '' : 'launchpad__app--disabled'}`}>

                {
                    (app.Workflow && !app.AdministratorCredentialSupplied) &&
                    <div className={'launchpad__app-menu'}>
                        <PasslyButton onClick={handleClick}>
                            <MoreVertIcon />
                        </PasslyButton>
                        <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={() => updateApp()}>{translation('UPDATE_APP')}</MenuItem>
                            <MenuItem onClick={() => deleteApp(app.Id)}>{translation('DELETE_APP')}</MenuItem>
                            <MenuItem onClick={() => reportApp(app.Id)}>{translation('FLAG_APP')}</MenuItem>
                        </Menu>
                    </div>
                }
                <a href={launchUrl()} target={target()}>
                    <div className={'launchpad__app-icon'}>
                        <img src={app.IconUrl} />
                    </div>
                </a>

                <div className='launchpad__app-name'>
                    <p>{translation(app.DisplayName)}</p>
                </div>
            </div>
        </>
    );
};

export default LaunchPadApp;
